var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-news-classify-form',{ref:"form",staticClass:"pt-news-classify-form__withData",attrs:{"id":_vm.id,"isEdit":_vm.isEdit,"form":_vm.categry}})}
var staticRenderFns = []

export { render, staticRenderFns }